// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { lazyLoadKeyframes } from "@store/Themes/common/mixins/lazyload";
import { loadingDotsKeyFrames } from "@store/Themes/common/mixins/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const globalStyle: Styleguide["globalStyle"] = {
    css: css`
        ${lazyLoadKeyframes()}
        ${loadingDotsKeyFrames()}

        /* Store Custom Code - Start */
        .modal-backdrop {
            display: none;
        }
        /* Store Custom Code - End */

        /* -- Form ------------------------------------------------------------ */

        input,
        textarea {
            &::placeholder {
                color: ${getColor("placeholder")};
                opacity: 1;
            }

            &:disabled,
            &.disabled {
                &::placeholder {
                    color: ${getColor("placeholder.disabled")};
                }
            }
        }

        fieldset {
            width: 100%;
            padding: 0;
            margin: 0;
            border: 0;
        }

        /* stylelint-disable property-no-vendor-prefix */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield !important;
        }
        /* stylelint-enable property-no-vendor-prefix */

        input:placeholder-shown::-webkit-search-cancel-button {
            display: none;
        }

        input:not(:placeholder-shown)::-webkit-search-cancel-button {
            padding: ${pxToRem(1)};
            margin: 0 ${pxToRem(14)};
            cursor: pointer;
        }

        /* -- Print ----------------------------------------------------------- */

        @media print {
            body {
                font-size: inherit !important;
            }

            h1 {
                font-size: 26px !important;
            }

            /* Store Custom Code - Start */
            *::before,
            *::after {
                content: none !important;
                display: none !important;
            }
            /* Store Custom Code - End */
        }
    `,
};

export default globalStyle;
